import styled from 'styled-components';

import Button from '@ui/atoms/Button';

import theme from '@theme/FolxTheme';

export default styled.div`
	align-items: center;
	display: flex;
	gap: ${theme.spacing.sm};

	${Button} {
		width: 100%;
	}

	@media ${theme.responsive.breakpoints.tablet} {
		justify-content: flex-end;
		${Button} {
			max-width: 16rem;
		}
	}
`;
